/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IModuleProps } from '@msdyn365-commerce-modules/utilities';

import { IAlphabetListData } from './alphabet-list.data';
import { IAlphabetListProps, IAlphabetItemsDetailsData } from './alphabet-list.props.autogenerated';

export interface IAlphabetListViewProps extends IAlphabetListProps<IAlphabetListData> {
    alphapetContainer: IModuleProps;
    letterItems: React.ReactNode;
}

/**
 *
 * AlphabetList component
 * @extends {React.PureComponent<IAlphabetListProps<IAlphabetListData>>}
 */
class AlphabetList extends React.PureComponent<IAlphabetListProps<IAlphabetListData>> {
    public render(): JSX.Element | null {

        const viewProps: IAlphabetListViewProps = {
            ...(this.props as IAlphabetListProps<IAlphabetListData>),
            alphapetContainer: {
                moduleProps: this.props,
                className: 'AlphabetList'
            },
            letterItems: this._renderLetter(this.props.config.alphabetItemsDetails, this.props.config.displayTwoColumns, this.props.config.letterToSplitAt)
        };

        return this.props.renderView(viewProps);
    }

    private _renderLetter(alphabetItemsDetails?: IAlphabetItemsDetailsData[], displayTwoColumns?: boolean, letterToSplitAt?: string): JSX.Element {
        if (displayTwoColumns) {
            return this._renderSplitColumn(alphabetItemsDetails, letterToSplitAt)
        }

        return this._renderSingleColumn(alphabetItemsDetails)
    }

    private _renderItem(alphabetItemDetail: IAlphabetItemsDetailsData): JSX.Element {
        return (
            <div className="AlphabetList_item_container">
                <h3>{alphabetItemDetail.letter}</h3>
                <hr />
                <div className="AlphabetList_item_list">
                    {alphabetItemDetail.subMenus?.map(item => {
                        return (
                            <>
                                <a href={item.link} target={item.openInNewTab ? "_blank" : ""}>{item.name}</a>
                            </>
                        )
                    })}
                </div>
            </div>
        );
    }

    private _renderSplitColumn(alphabetItemsDetails?: IAlphabetItemsDetailsData[], letterToSplitAt?: string): JSX.Element {
        let leftSide = true;
        const leftListNode: JSX.Element[] = [];
        const rightListNode: JSX.Element[] = [];
        alphabetItemsDetails?.forEach(alphabetItem => {

            if (alphabetItem.letter === letterToSplitAt) {
                leftSide = false
            }

            if (leftSide) {
                leftListNode.push(this._renderItem(alphabetItem))
            } else {
                rightListNode.push(this._renderItem(alphabetItem))
            }
        })

        return (
            <div className='AlphabetList_splitlist'>
                <div className='AlphabetList_leftColumn'>{leftListNode}</div>
                <div className='AlphabetList_rightColumn'>{rightListNode}</div>
            </div>
        )
    }

    private _renderSingleColumn(alphabetItemsDetails?: IAlphabetItemsDetailsData[]): JSX.Element {
        const listNode = alphabetItemsDetails?.map(alphabetItem => {
            return this._renderItem(alphabetItem)
        })

        return (
            <>
                {listNode}
            </>
        )
    }
}

export default AlphabetList;
